// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CustomerInformation_wrapper__4vyfL","title":"CustomerInformation_title__1HQ8u","name":"CustomerInformation_name__AnPjV","email":"CustomerInformation_email__5dqes"};